<template lang='pug'>
  div(class='yearly-line-chart' )
</template>
<script>
import echarts from 'echarts/lib/echarts'

// import the util you want
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/graphic'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/axis'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/markLine'
import 'echarts/lib/chart/candlestick'
import 'echarts/theme/shine.js'
export default {
  props: {
    yearlyData: Object
  },

  /**
   * 折线（区域）图、柱状（条形）图: a（系列名称），b（类目值），c（数值）, d（无）
   */
  data () {
    return {
      echarts,
      lineChart: null,
      months: [
        '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'
      ],
      option: {
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            show: false
          },
          axisPointer: true,
          axisTick: false
        },
        grid: {
          left: '5%',
          top: '10%',
          right: '5%',
          bottom: '3%'
        },
        yAxis: {
          // data: [0, 1000, 2000, 3000],
          axisTick: false,
          axisLine: {
            show: false
          }
        },
        // dataZoom: [{
        //   startValue: '2014-06-01'
        // }, {
        //   type: 'inside'
        // }],
        series: [

        ],
        color: ['#189f96', '#FEBF04', '#0563EF']
      }
    }
  },
  // mounted () {
  //   this.pieChart = this.echarts.init(document.getElementsByClassName('yearly-line-chart')[0])
  //   this.pieChart.setOption(this.option)
  // }
  watch: {
    yearlyData () {
      this.option.series = []
      this.option.xAxis.data = this.yearlyData.xAxis
      this.option.series.push({
        name: '總量',
        type: 'line',
        data: this.yearlyData.total,
        smooth: true
      })
      this.option.series.push({
        name: '不可回收',
        type: 'line',
        data: this.yearlyData.trash,
        smooth: 'spline'
      })
      this.option.series.push({
        name: '回收',
        type: 'line',
        data: this.yearlyData.recycling,
        smooth: 'spline'
      })
      this.lineChart = this.echarts.init(document.getElementsByClassName('yearly-line-chart')[0])
      this.lineChart.setOption(this.option)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "@/assets/scss/helper/variables.scss";

.yearly-line-chart {
  height: 100%;
  width: 100%;
}
</style>
